import { Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DividerComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}


}



// WEBPACK FOOTER //
// ./src/app/features/divider/divider.component.ts